import React, { FC, HTMLAttributes } from "react";
import {
  useTransition,
  animated,
  config as defaultConfig,
  UseTransitionProps,
} from "@react-spring/web";
import styled from "styled-components";

interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  height?: string;
}

const Wrapper = styled(animated.div)<WrapperProps>`
  height: ${({ height }) => height || "100%"};
  width: fit-content;
  position: absolute;
`;
interface TransitionProps
  extends Partial<UseTransitionProps>,
    Partial<HTMLAttributes<HTMLDivElement>> {
  show?: boolean;
  transitionActive?: boolean;
  from?: React.CSSProperties;
  leave?: React.CSSProperties;
  enter?: React.CSSProperties;
  easing?: keyof typeof defaultConfig;
  duration?: number;
  style?: React.CSSProperties;
  config?: {
    tension?: number;
    friction?: number;
  };
}
const defaultHide = {
  opacity: 0,
  y: 0,
  x: 100,
  scale: 1.05,
  transformOrigin: "50% 50%",
};
const defaultShow = {
  opacity: 1,
  y: 0,
  x: 0,
  scale: 1,
};
const Transition: FC<TransitionProps> = ({
  children,
  show,
  transitionActive,
  from,
  leave,
  enter,
  config,
  style: wrapperStyle,
  easing = "gentle",
  ...props
}) => {
  const transition = useTransition(show, {
    from: { ...defaultHide, ...from },
    leave: { ...defaultHide, ...leave },
    enter: { ...defaultShow, ...enter },
    config: config || defaultConfig[easing],
    ...props,
  });

  if (transitionActive === false) return show ? <>{children}</> : null;

  return transition(
    (style, show) =>
      show && (
        <Wrapper
          style={{ ...wrapperStyle, ...style }}
          {...props}
        >
          {children}
        </Wrapper>
      )
  );
};

export default Transition;
